import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import CartOrderSummary from "./CartOrderSummary";
import Checkout from "../Checkout";
import "./CartSummary.scss";
import get from "lodash/get";

const CartSummary = (props) => (
  <section
    className={cx("cart-summary container-guttered", {
      "cart-summary--margin-top": !get(
        props.model,
        "prismicGlobalContentModel.freeShipping.enableInCartItems",
        false
      ),
    })}
  >
    <div className="padded-wrapper">
      <h2 className="cart-summary-title">{props.title}</h2>
      <div className="cart-summary-container">
        <CartOrderSummary
          itemCount={props.summary.items.length}
          label={props.labels}
          value={props.values}
          removeCta={props.discountFormRemoveCta}
          hideShippingPrice
        />
      </div>
    </div>
    <div
      className={cx("cart-summary-payment", {
        "payment-icons-hidden": props.hidePaymentIcons,
      })}
    >
      <Checkout
        checkoutCta={props.checkoutCta}
        checkoutUrl={props.checkoutUrl}
        quickCheckoutLabel={props.quickCheckoutLabel}
        positionDiscountFormFirst={props.positionDiscountFormFirst}
        description={props.discountFormDescription}
        cta={props.discountFormCta}
        hidePaypalButton={props.hidePaypalButton}
        paypalUrl={props.paypalUrl}
        placeholder={props.discountFormPlaceholder}
        exclusionList={props.paymentIconExclusions}
        hidePaymentIcons={props.hidePaymentIcons}
        isAccordionExpanded={props.isAccordionExpanded}
        paymentMethodsLabel={props.paymentMethodsLabel}
        sortOrder={props.sortOrder}
      />
    </div>
  </section>
);

CartSummary.propTypes = {
  model: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  checkoutCta: PropTypes.string.isRequired,
  discountFormCta: PropTypes.string.isRequired,
  discountFormRemoveCta: PropTypes.string.isRequired,
  discountFormPlaceholder: PropTypes.string.isRequired,
  discountFormDescription: PropTypes.array.isRequired,
  labels: PropTypes.object.isRequired,
  values: PropTypes.object.isRequired,
  summary: PropTypes.shape({
    promoCode: PropTypes.string,
    items: PropTypes.array,
  }),
  quickCheckoutLabel: PropTypes.string,
  paymentMethodsLabel: PropTypes.string,
  checkoutUrl: PropTypes.string,
  paypalUrl: PropTypes.string,
  paymentIconExclusions: PropTypes.arrayOf(PropTypes.string),
  hidePaypalButton: PropTypes.bool,
  hidePaymentIcons: PropTypes.bool,
  isAccordionExpanded: PropTypes.bool,
  positionDiscountFormFirst: PropTypes.bool,
  sortOrder: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default CartSummary;
